module.exports = __webpack_public_path__ + "static/media/logo.0d4d6881.svg";